import { useState } from "react";
import { Link } from "react-router-dom";
import PopupLightbox from "../components/PopupLightbox";

import imgCloseIcon from "../images/icon-close.png";

import kevinS from "../images/bio/kevin-s.jpg";
import rayM from "../images/bio/ray-m.jpg";
import lynnM from "../images/bio/lynn-m.jpg";
import keyS from "../images/bio/key-s.jpg";
// import anon from "../images/bio/anonymous.png";

const Emeriti = () => {
  const [buttonPopup1, setButtonPopup1] = useState(false);
  const [buttonPopup2, setButtonPopup2] = useState(false);
  const [buttonPopup3, setButtonPopup3] = useState(false);
  const [buttonPopup4, setButtonPopup4] = useState(false);

  return (
    <div className="grid-container dark-bg">
      <div className="popup-wrapper">
        <div className="popup-col colA">
          <div className="popup-col-inner">
            <h2>Emeriti</h2>
            <Link className="close-btn" to="/">
              <img src={imgCloseIcon} alt="close button" />
            </Link>

            <ul className="circle-container">
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${rayM})` }}
                  onClick={() => setButtonPopup1(true)}
                >
                  <span>Rayman Meservy</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${lynnM})` }}
                  onClick={() => setButtonPopup2(true)}
                >
                  <span>Lynn McKell</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${kevinS})` }}
                  onClick={() => setButtonPopup3(true)}
                >
                  <span>Kevin Stocks</span>
                </button>
              </li>
              <li>
                <button
                  className="image-btn image-link"
                  style={{ backgroundImage: `url(${keyS})` }}
                  onClick={() => setButtonPopup4(true)}
                >
                  <span>Kay Stice</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <PopupLightbox trigger={buttonPopup1} setTrigger={setButtonPopup1} columnPosition="colB">
        <h3>Rayman Meservy</h3>
        <p>
          <iframe
            src="https://www.youtube.com/embed/DMh8rCvb1bI"
            title="Rayman Meservy emeriti interview"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            className="video-player"
          ></iframe>
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup2} setTrigger={setButtonPopup2} columnPosition="colB">
        <h3>Lynn McKell</h3>
        <p>
          <iframe
            src="https://www.youtube.com/embed/5vJF7vX4vUc"
            title="Lynn Mckell emeriti interview"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            className="video-player"
          ></iframe>
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup3} setTrigger={setButtonPopup3} columnPosition="colB">
        <h3>Kevin Stocks</h3>
        <p>
          <iframe
            src="https://www.youtube.com/embed/OH0a7VL3wdc"
            title="Kevin Stocks emeriti interview"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
            className="video-player"
          ></iframe>
        </p>
      </PopupLightbox>
      <PopupLightbox trigger={buttonPopup4} setTrigger={setButtonPopup4} columnPosition="colB">
        <h3>Kay Stice</h3>
        <p>
          <iframe
            src="https://www.youtube.com/embed/v2UsMwGYdso"
            title="Kay Stice emeriti interview"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
            className="video-player"
          ></iframe>
        </p>
      </PopupLightbox>
    </div>
  );
};

export default Emeriti;
